import {useState} from "react";

// Components

// Images
import newImage from '../assets/img/partnerPortal/welcomePage/new.png';
// Scss
// import '../assets/css/partnerProgram.scss';
import '../assets/css/partnerPortal/welcome.scss';


function ContactRow(props) {


  const [name] = useState(props.name);
  const [title] = useState(props.title);
  const [email] = useState(props.email);
  const [phoneNumber] = useState(props.phoneNumber);
  //const [image] = useState(props.image);

  return (
    <>
      
    <div className="contactRow mb-4">
        <div >
            {/* {image ? <img src={image} width={"150%"} /> : ""} */}
        </div>
        <div className="contactInfo">
            <div className="contactInfoDetail">
                <div className="contactGeneral fontWeight800">{name}</div>
                <div className="contactGeneral fontWeight400">{title}</div>
            </div>
            <div className="contactInfoDetail">
                <a href={"mailto: " + email}>
                    <div className="contactGeneral fontWeight600 blueColor">{email}</div>
                </a>
                <div className="contactGeneral fontWeight600">{phoneNumber}</div>
            </div>
        </div>
    </div>
            
    </>
  );


}

export default ContactRow;

